import { useIsMobile } from '@/utils/isMobile';
import { Box } from '@mui/material';

export default function TopLevelSectionLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const isMobile = useIsMobile();

  return (
    <Box sx={{ p: isMobile ? '16px 0px 0px' : '40px 49px 49px' }}>
      {children}
    </Box>
  );
}
